import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_findYourPathLanding.css'
import cities from './cities'
import screen from 'images/landing/find-your-path/screen.png'

function FindYourPath () {
  return (
    <div className={styles.findYourPath}>
      <Title align="center">
        <FormattedMessage id='landingPage.findYourPath.title' defaultMessage={`Find Your Path \nAnywhere`} />
      </Title>
      <Caption align="center">
        <FormattedMessage id='landingPage.findYourPath.caption' defaultMessage="Create and discover new routes wherever you are. Save your favorites for the next time you're ready to run." />
      </Caption>
      <Cities />
      <div className={styles.routes}>
        <img src={screen} />
      </div>
    </div>
  )
}

function Cities () {
  const cityList = cities.map((city, i) => <City key={`${city.slug}-${i}`} name={city.name} slug={city.slug} />)
  const numberOfColumns = 3
  const columnSize = Math.ceil(cityList.length / numberOfColumns)
  const cityColumns = []

  while (cityList.length) {
    cityColumns.push(cityList.splice(0, columnSize))
  }

  const cityColumnList = cityColumns.map((column, i) => <ul key={i} className={styles.cityColumn}>{column}</ul>)

  return (
    <div className={styles.cities}>
      {cityColumnList}
    </div>
  )
}

function City (props) {
  const { slug, name } = props
  return (
    <li className={styles.city}>
      <a href={slug}>{name}</a>
    </li>
  )
}

City.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
}

export default FindYourPath



// WEBPACK FOOTER //
// ./src/components/landing/find-your-path/index.jsx